export default function DateCell({ value, showTime = false }) {
    if (!value) return "";

    const date = new Date(value);

    return showTime
        ? date.toLocaleString("en-IN")
        : date.toLocaleDateString("en-IN");
}